import { getData } from "../api/api";

/** Keep in sync with backend AuditAction enum. */
export type AuditAction =
  | "DASHBOARD_VIEW"
  | "DASHBOARD_EXPORT_PDF"
  | "DASHBOARD_EXPORT_XLSX"
  | "SHARE_CREATE"
  | "SHARE_REVOKE"
  | "SHARE_PUBLIC_EXECUTE"
  | "SHARE_PASSWORD_AUTH"
  | "ANOMALY_DEFINITION_CREATE"
  | "ANOMALY_DEFINITION_UPDATE"
  | "ANOMALY_DEFINITION_DELETE"
  | "ANOMALY_PLUGIN_DETECTOR_START"
  | "ANOMALY_PLUGIN_DETECTOR_STOP"
  | "ANOMALY_PLUGIN_DETECTOR_DELETE"
  | "ANOMALY_INCIDENT_UPDATE"
  | "ANOMALY_OS_DOC_UPDATE"
  | "ANOMALY_DRAFT_APPLY"
  | "ANOMALY_DRAFT_REJECT"
  | "FORECAST_ANALYSIS_CONSENT"
  | "FORECAST_ANALYSIS_RUN"
  | "FORECAST_ANALYSIS_REJECT"
  | "OPENSEARCH_SAMPLE_CONSENT"
  | "OPENSEARCH_SAMPLE_RUN"
  | "SCHEMA_ANALYZE"
  | "SCHEMA_SAMPLE_CONSENT"
  | "SCHEMA_EDGE_UPSERT"
  | "SCHEMA_NODE_UPSERT"
  | "SCHEMA_NODE_DELETE"
  | "SCHEMA_EDGE_DELETE"
  | "SCHEMA_PUBLISH"
  | "CHAT_MAIL_DRAFT_CREATE"
  | "CHAT_MAIL_SEND"
  | "CHAT_HISTORY_DELETE"
  | "CHAT_HISTORY_ADMIN_READ"
  | "CHAT_QUERY_EXAMPLE_PROMOTE"
  | "CHAT_QUERY_EXAMPLE_DELETE"
  | "GUIDE_UPLOAD"
  | "GUIDE_DELETE"
  | "GUIDE_REINGEST"
  | "MAPPING_TRANSFER_TO_RAG"
  | "MAPPING_RAG_DELETE"
  | "OPENAPI_MUTATION_APPLY"
  | "OPENAPI_MUTATION_REJECT"
  | "PII_RULE_CREATE"
  | "PII_RULE_UPDATE"
  | "PII_RULE_DELETE"
  | "INGEST_GRANT_UPSERT"
  | "INGEST_GRANT_DELETE"
  | "EMBED_CREATE"
  | "EMBED_UPDATE"
  | "EMBED_DELETE"
  | "EMBED_ROTATE"
  | "EMBED_LOGIN"
  | "EMBED_LOGIN_DENIED"
  | "EMBED_PAGE_CONTENT_CONSENT"
  | "OPENSEARCH_POLICY_UPDATE";

export const AUDIT_ACTIONS: AuditAction[] = [
  "DASHBOARD_VIEW",
  "DASHBOARD_EXPORT_PDF",
  "DASHBOARD_EXPORT_XLSX",
  "SHARE_CREATE",
  "SHARE_REVOKE",
  "SHARE_PUBLIC_EXECUTE",
  "SHARE_PASSWORD_AUTH",
  "ANOMALY_DEFINITION_CREATE",
  "ANOMALY_DEFINITION_UPDATE",
  "ANOMALY_DEFINITION_DELETE",
  "ANOMALY_PLUGIN_DETECTOR_START",
  "ANOMALY_PLUGIN_DETECTOR_STOP",
  "ANOMALY_PLUGIN_DETECTOR_DELETE",
  "ANOMALY_INCIDENT_UPDATE",
  "ANOMALY_OS_DOC_UPDATE",
  "ANOMALY_DRAFT_APPLY",
  "ANOMALY_DRAFT_REJECT",
  "FORECAST_ANALYSIS_CONSENT",
  "FORECAST_ANALYSIS_RUN",
  "FORECAST_ANALYSIS_REJECT",
  "OPENSEARCH_SAMPLE_CONSENT",
  "OPENSEARCH_SAMPLE_RUN",
  "SCHEMA_ANALYZE",
  "SCHEMA_SAMPLE_CONSENT",
  "SCHEMA_EDGE_UPSERT",
  "SCHEMA_NODE_UPSERT",
  "SCHEMA_NODE_DELETE",
  "SCHEMA_EDGE_DELETE",
  "SCHEMA_PUBLISH",
  "CHAT_MAIL_DRAFT_CREATE",
  "CHAT_MAIL_SEND",
  "CHAT_HISTORY_DELETE",
  "CHAT_HISTORY_ADMIN_READ",
  "CHAT_QUERY_EXAMPLE_PROMOTE",
  "CHAT_QUERY_EXAMPLE_DELETE",
  "GUIDE_UPLOAD",
  "GUIDE_DELETE",
  "GUIDE_REINGEST",
  "MAPPING_TRANSFER_TO_RAG",
  "MAPPING_RAG_DELETE",
  "OPENAPI_MUTATION_APPLY",
  "OPENAPI_MUTATION_REJECT",
  "PII_RULE_CREATE",
  "PII_RULE_UPDATE",
  "PII_RULE_DELETE",
  "INGEST_GRANT_UPSERT",
  "INGEST_GRANT_DELETE",
  "EMBED_CREATE",
  "EMBED_UPDATE",
  "EMBED_DELETE",
  "EMBED_ROTATE",
  "EMBED_LOGIN",
  "EMBED_LOGIN_DENIED",
  "EMBED_PAGE_CONTENT_CONSENT",
  "OPENSEARCH_POLICY_UPDATE",
];

export type AuditEvent = {
  id: string;
  occurredAt: string;
  actorUsername?: string;
  action: AuditAction | string;
  resourceType?: string;
  resourceId?: string;
  tenantId?: string;
  metadata?: Record<string, unknown>;
};

type PagedAuditResponse = {
  content?: AuditEvent[];
  totalElements?: number;
  number?: number;
  size?: number;
  totalPages?: number;
};

export const auditService = {
  list: async (
    from?: string,
    to?: string,
    action?: AuditAction,
    resourceType?: string
  ): Promise<PagedAuditResponse> => {
    const params = new URLSearchParams();
    if (resourceType) params.append("resourceType", resourceType);
    if (from) params.append("from", from);
    if (to) params.append("to", to);
    if (action) params.append("action", action);
    params.append("size", "200");
    params.append("sort", "occurredAt,desc");

    const query = params.toString();
    const endpoint = `/admin/audit-events?${query}`;
    return getData(endpoint);
  },
};
